import { SearchDocumentSortBy } from "@app/modules/documents/constants";
import { SortCriteriaDirection } from "@app/models/constants";

// Documents Search Request
export interface DocumentSearchRequest {
    searchCriterias: DocumentSearchCriterias;
}

export type DocumentSearchCriterias = Partial<SearchCriterias>;

interface SearchCriterias {
    title: string;
    language: string;
    sortBy: SearchDocumentSortBy;
    sortOrder: SortCriteriaDirection;
    limit: number;
    offset: number;
}

// Documents Search Response
export interface DocumentSearchResponse {
    documents: DocumentSearchResult[];
    totalMatchedRecords: number;
}

export interface DocumentSearchResult {
    documentMetaDataId: string;
    title: string;
    category: string;
    createdDate: string;
    language: string;
}

export interface SortCriteria {
    columnName: SearchDocumentSortBy;
    direction: SortCriteriaDirection;
}

export const defaultDocumentAndFormsConfig: DocumentsAndFormDefinition = {
    documentSortCriteria: {
        columnName: SearchDocumentSortBy.Title,
        direction: SortCriteriaDirection.Asc,
    },
};
